import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flag, X, ArrowRight } from "lucide-react";
import axios from "axios";
import { API } from "../lib/api";

const DISMISS_KEY = "the_south_topbar_dismissed_v1";

export const TheSouthTopBar = () => {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });
  const [total, setTotal] = useState(null);

  useEffect(() => {
    if (dismissed) return;
    axios.get(`${API}/the-south/stats`).then(r => setTotal(r.data?.total ?? 0)).catch(() => {});
  }, [dismissed]);

  if (dismissed) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch (e) { /* localStorage not available */ }
    setDismissed(true);
  };

  return (
    <Link to="/the-south" className="block group" data-testid="the-south-topbar">
      <div
        className="relative text-white text-sm py-2 px-3 md:px-6"
        style={{
          background: "linear-gradient(90deg, #1a0000 0%, #4a0a0a 50%, #1a0000 100%)",
        }}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 md:gap-4 text-center pr-8">
          <Flag className="w-4 h-4 text-amber-300 flex-shrink-0 hidden sm:inline" />
          <span className="font-bold tracking-wide truncate">
            <span className="text-red-400">THE SOUTH</span> GOT SOMETHING <span className="text-amber-300">TO SAY</span>
          </span>
          <span className="hidden md:inline text-slate-300">· Educate · Organize · Mobilize</span>
          {total !== null && total > 0 ? (
            <span className="hidden sm:inline bg-white/10 border border-white/20 rounded-full px-2 py-0.5 text-xs">
              <strong className="text-amber-200">{total.toLocaleString()}</strong> signed on
            </span>
          ) : null}
          <span className="inline-flex items-center gap-1 text-amber-200 group-hover:text-amber-100 font-semibold whitespace-nowrap">
            Take the Pledge <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </div>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white p-1 rounded-full hover:bg-white/10 transition-colors"
          data-testid="the-south-topbar-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </Link>
  );
};
